export const customErrorBulkMessage = error => {
  let errorMessage = 'Error al actualizar productos';

  if (error.error === 'ProductOfferPriceError') {
    errorMessage = 'El precio de oferta debe ser menor que el precio regular';
  }

  if (error.message === 'Document validation') {
    errorMessage = 'El documento no es válido';
  }

  return errorMessage;
};
